import React from 'react';
import SubSection from '../../../libs/react-components-admin/section/sub-section';

export default class ConditionId extends React.Component {

  constructor(props) {
    super(props);
    const value = ConditionId.valueOrNullIfInvalid(props.value, props.conditions);
    if (value !== props.value) {
      props.onChange(value);
    }
    this.state = {
      conditions: props.conditions,
      value: value,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.conditions === nextProps.conditions) {
      return null;
    }
    const state = {
      conditions: nextProps.conditions,
      value: ConditionId.valueOrNullIfInvalid(prevState.value, nextProps.conditions),
    };
    if (state.value !== prevState.value) {
      nextProps.onChange(state.value);
    }
    return state;
  }

  static valueOrNullIfInvalid(value, conditions) {
    if (!conditions || conditions.length === 0 || !value) {
      return null;
    } else {
      return conditions.some(c => c.id === value) ? value : null;
    }
  }

  updateValue(value) {
    this.setState(
      {value: value},
      () => this.props.onChange(this.state.value)
    );
  }

  render() {
    const title = <div className="form-check">
      <input type="checkbox"
             id={this.props.id + 'ConditionEnabled'}
             className="form-check-input"
             style={{width: '0.8em', height: '0.8em', marginTop: '5px'}}
             checked={!!this.state.value}
             onChange={e => this.updateValue(e.target.checked ? this.state.conditions[0].id : null)}
             disabled={(this.state.conditions || []).length === 0}/>
      <label htmlFor={this.props.id + 'ConditionEnabled'} className="form-check-label" style={{cursor: 'pointer'}}>
        Display this field conditionally
      </label>
      {(this.state.conditions || []).length === 0 &&
        <div className="form-text">Please add a field condition to the form first</div>
      }
    </div>;
    return <SubSection title={title} className="mb-3">
      {this.state.value && (this.state.conditions || []).length > 0 &&
        <div className="mb-3 ms-md-4">
          <label htmlFor={this.props.id + 'ConditionId'} className="form-label">
            Condition that needs to be satisfied
          </label>
          <select id={this.props.id + 'ConditionId'}
                  className="form-select"
                  value={this.state.value || ''}
                  onChange={e => this.updateValue(e.target.value)}>
            {this.state.conditions.map(condition =>
              <option key={condition.id} value={condition.id}>{condition.name}</option>
            )}
          </select>
        </div>
      }
    </SubSection>;
  }

}
